import * as dateFns from 'date-fns';

import { MatchSchedule } from './match-schedule';

import { Group } from '../models/group.model';
import { MatchConfig, MatchCycle } from '../models/match.interfaces';

import get from 'lodash-es/get';
import isEmpty from 'lodash-es/isEmpty';
import isUndefined from 'lodash-es/isUndefined';

const getScheduleFromMatchCycle = (matchCycle: MatchCycle) => {
  return {
    primer: get(matchCycle, 'off_platform_schedule.primer'),
    introduction: get(matchCycle, 'off_platform_schedule.introduction'),
    reminder: get(matchCycle, 'off_platform_schedule.reminder'),
    feedback: get(matchCycle, 'off_platform_schedule.feedback'),
  };
};

const getScheduleFromMatchConfig = (group: Group, matchConfig: MatchConfig) => {
  const tomorrow = dateFns.addDays(dateFns.startOfDay(Date.now()), 1);
  const nextCycleStart = dateFns.max([
    tomorrow,
    dateFns.startOfDay(new Date(group.match_start_date)),
  ]);
  const dateOffsets = matchConfig.off_platform_schedule_offsets;
  if (isEmpty(dateOffsets)) {
    return { introduction: nextCycleStart };
  }
  return {
    primer: !isUndefined(dateOffsets.primer)
      ? dateFns.addDays(nextCycleStart, dateOffsets.primer)
      : '',
    introduction: !isUndefined(dateOffsets.introduction)
      ? dateFns.addDays(nextCycleStart, dateOffsets.introduction)
      : nextCycleStart,
    reminder: !isUndefined(dateOffsets.reminder)
      ? dateFns.addDays(nextCycleStart, dateOffsets.reminder)
      : '',
    feedback: !isUndefined(dateOffsets.feedback)
      ? dateFns.addDays(nextCycleStart, dateOffsets.feedback)
      : '',
  };
};

export function calculateMatchSchedule(options: {
  group: Group;
  matchConfig: MatchConfig;
  matchCycle?: MatchCycle;
  matchCyclePreview?: MatchCycle;
}): MatchSchedule {
  const providedMatchCycle = options.matchCycle || options.matchCyclePreview;
  if (providedMatchCycle) {
    return getScheduleFromMatchCycle(providedMatchCycle);
  }
  return getScheduleFromMatchConfig(options.group, options.matchConfig);
}

export function calculateNextIntroStartDate(
  introDate: Date,
  periodLength: number,
  periodUnit: string,
) {
  if (dateFns.isAfter(introDate, new Date())) {
    return introDate;
  }

  if ('weeks' === periodUnit) {
    return dateFns.addWeeks(introDate, periodLength);
  }

  if ('months' === periodUnit) {
    return dateFns.addMonths(introDate, periodLength);
  }
}
